
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lokalizatory-gps-i-czujniki-iot",
      function () {
        return require("private-next-pages/lokalizatory-gps-i-czujniki-iot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lokalizatory-gps-i-czujniki-iot"])
      });
    }
  